import { Injectable } from '@angular/core';
import {AngularFireDatabase} from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private afdatabase: AngularFireDatabase) { }

  setUser(user) {
    return this.afdatabase.object('/users/' + user.uid).set(user);
  }
  getUserById(uid) {
    return this.afdatabase.object('/users/' + uid);
  }
  getUser(){
    return this.afdatabase.list('/users/');
  }
  addProject(request, action) {
    return this.afdatabase.object('/users/' + request.sender + '/products/' + request.product.pid).set(action);
  }
  getProjectsByUserId(uid) {
    return this.afdatabase.list('/users/' + uid + '/products/');
  }
  setActivity(activity) {
    return this.afdatabase.object('/activity/' + activity.uid + '/' + activity.timestamp).set(activity);
  }
  setActive(active) {
    return this.afdatabase.object('/users/' + active.uid + '/active').set(active.value);
  }
}
